import { ScrollModal } from "../../../shared/scroll-modal";
import { OptionButton } from "../../../shared/option-button";
import { LoginForm } from "../../../shared/login-form";
import React, { forwardRef, useRef } from "react";
import { auth } from "../../../../firebase";
import toast from "react-hot-toast";
import useSongStore from "../store/SongState";
import { ModalApi } from "../../../shared/login-form/view";
import useUserStore from "../../../../store/UserState";
import { useNavigate } from "react-router-dom";
import { APP_VERSION } from "../../../../consts";

interface Props {
    handleNavigate: (route: string) => void;
}

const AppOptionsModal = forwardRef<ModalApi, Props>((props, ref) => {

    const { emptyQueue, emptyHistory } = useSongStore(state => state);
    const loginModalFormRef = React.useRef<ModalApi>(null);
    const navigate = useNavigate();

    const { user, offlineMode } = useUserStore(state => state.state);


    const handleOpenLoginForm = () => {
        loginModalFormRef.current?.open();
    }

    const handleSingout = () => {
        auth.signOut();
    }

    const handleEmptyQueue = () => {
        emptyQueue();
        toast.success("Se ha vaciado la cola");
    }

    const handleEmptyHist = () => {
        emptyHistory();
        toast.success("Se ha limpiado el historial");
    }

    const reloadPage = () => {
        window.location.reload();
    }

    return (

        <ScrollModal ref={ref} header={
            <div className="spotipitan__app-options-modal__header">
                <span className="spotipitan__app-options-modal__header__title">Opciones Spotip17an</span>
                <span className="spotipitan__app-options-modal__header__version">v{APP_VERSION}</span>
            </div>}>
            <div className="spotipitan__app-options-modal__body pt-3">
                <div className="spotipitan__app-options-modal__body__title">Reproductor</div>
                <OptionButton onClick={handleEmptyQueue} text="Vaciar cola"
                    icon={<i className="fa-solid fa-broom"></i>} />
                <OptionButton onClick={handleEmptyHist} text="Eliminar historial"
                    icon={<i className="fa-solid fa-clock-rotate-left"></i>} />
                <div className="spotipitan__app-options-modal__body__title">Otros</div>
                {!!user?.uid && !offlineMode &&
                    <OptionButton icon={<i className="fa-solid fa-user"></i>} text="Mi perfil"
                        title={"Mi perfil"} onClick={() => props.handleNavigate('my-user')} />}
                {!!user?.uid &&
                    <OptionButton icon={<i className="fa-solid fa-palette"></i>} text="Personalizar"
                        title={"Personalizar"} onClick={() => props.handleNavigate('customize')} />}
                {!user?.uid && !offlineMode &&
                    <OptionButton icon={<i className="fa-solid fa-user"></i>} text="Iniciar sesión"
                        title={"Iniciar sesión"} onClick={handleOpenLoginForm} />}
                {!!user?.uid && !offlineMode && <OptionButton onClick={handleSingout} text="Cerrar sesión" icon={<i
                    className="fa-solid fa-right-from-bracket"></i>} />}
                <OptionButton onClick={reloadPage} text="Recargar página" icon={<i
                    className="fa-solid fa-rotate-right"></i>} />
                <div className="spotipitan__app-options-modal__footer">
                    <span>Spotip17an</span>
                    <span>v{APP_VERSION}</span>
                </div>
            </div>
            <LoginForm ref={loginModalFormRef} />
        </ScrollModal>
    );
});

export default AppOptionsModal;
